import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getEmployeeCropReportData
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllActiveGroups', null)
    for (let item of Object.entries(response.data)) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}


async function getEmployeeCropReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.estateID),
        fromDate: data.fromDate,
        toDate: data.toDate,
        regNumber: data.regNumber,
        employeeType: parseInt(data.employeeType)
    };
    const response = await CommonPost('/api/EmployeeCropReport/GetEmployeeCropReportData', null, model);
    return response.data;
}
